/*eslint-disable*/
import React from "react";

// reactstrap components
import {
    Container, 
    Row,
    Col,
} from "reactstrap";
// core components

function IndexHeader2() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
      if (window.innerWidth > 991) {

      const updateScroll = () => {
          try {
              let windowScrollTop = window.pageYOffset / 3;
              pageHeader.current.style.transform =
                  "translate3d(0," + windowScrollTop + "px,0)";
          } catch (e) { }
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
          <div className="page-header clear-filter" /*filter-color="blue"*/ style={{ background: 'linear-gradient(0deg, rgba(44, 44, 44, 0.2), #2ca8ff)', minHeight: '60vh', maxHeight: '300px',marginBottom: '-30px' }}>
        <div
          className="page-header-image"
          style={{
              backgroundImage: "url(" + require("assets/img/bg_ts_front.png") + ")"
          }}
          ref={pageHeader}
        ></div>
        <Container>
          <div className="content-top brand">
                      {/*
              <img
              alt="..."
              className="n-logo"
              src={require("assets/img/now-logo.png")}
           ></img>
           */}
                      
          </div>
                  {/*
                  <div className="section-team text-center">
                      <Container>
                          <h2 className="title">ขั้นตอนการทำงาน</h2>
                          <div className="team">
                              <Row>
                                  <Col md="4" xs="4">
                                      <div className="team-player">
                                          <img
                                          style={{ maxWidth: '100px'}}
                                          alt="..."
                                          className="rounded-circle img-fluid img-raised"
                                              src={require("assets/img/avatar.jpg")}
                                          ></img>
                                          <p className="category text-info">ซักประวัติ</p>
                                          <p className="description">
                                              You can write here details about one of your team members.
                                              You can give more details about what they do. Feel free to add some{" "}
                                          </p>
                                      </div>
                                  </Col>
                                  <Col md="4" xs="4">
                                      <div className="team-player">
                                          <img
                                              style={{ maxWidth: '100px' }}
                                              alt="..."
                                              className="rounded-circle img-fluid img-raised"
                                              src={require("assets/img/ryan.jpg")}
                                          ></img>
                                          <p className="category text-info">ตรวจรักษา / ให้คำปรึกษา</p>
                                          <p className="description">
                                              You can write here details about one of your team members.
                                              You can give more details about what they do. Feel free to add some{" "}
                                          </p>
                                      </div>
                                  </Col>
                                  <Col md="4" xs="4">
                                      <div className="team-player">
                                          <img
                                              style={{ maxWidth: '100px' }}
                                              alt="..."
                                              className="rounded-circle img-fluid img-raised"
                                              src={require("assets/img/eva.jpg")}
                                          ></img>
                                          <p className="category text-info">ชำระเงินและจัดส่งยา</p>
                                          <p className="description">
                                              You can write here details about one of your team members.
                                              You can give more details about what they do. Feel free to add some{" "}
                                          </p>
                                      </div>
                                  </Col>
                              </Row>
                          </div>
                      </Container>
                  </div>
                  */}
        </Container>
      </div>
    </>
  );
}

export default IndexHeader2;
